// @ts-nocheck
// E-mail signups outside the planner (docs/email/SIGNUPS.md; API: vhp-planner src/app/api/signup/route.ts). One sheet
// (snippets/vhp-mail-signup.liquid), two kinds:
//  - recipe: [data-vhp-mail-recipe] buttons on a recipe (under the ingredients, next to Teilen / Drucken). A newsletter
//    signup with the recipe (servings on screen) as the reason, said plainly under the button (Maxim 2026-11-03); Klaviyo
//    sends the recipe once she confirmed the double opt-in.
//  - news: the menu row [data-vhp-mail-news]. Newsletter list only.
// Rules (Maxim, 2026-11-03: never overload, clear at a glance): nothing opens by itself; buttons stay hidden until the API
// says it can send; once she signed up here the menu row goes. The address is
// never kept in the browser; localStorage vhp_mail_signup only remembers that (newsletter) and when.
(() => {
  'use strict';

  if (window.vhpMailSignup) return;

  const KEY = 'vhp_mail_signup';
  const READY_KEY = 'vhp_mail_signup_ready';
  const READY_MS = 10 * 60 * 1000;
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const track = (name, params) => window.vhpTrack?.(name, params);

  const read = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(KEY) || 'null');
      return raw && typeof raw === 'object' ? raw : {};
    } catch (e) {
      return {};
    }
  };
  const write = (patch) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ ...read(), ...patch }));
    } catch (e) {
      /* private mode: the row may show again next visit */
    }
  };
  // On the list already: here, or through the planner's week mail box (assets/vhp-planner-weekmail.js keeps no flag for
  // the box, so only our own record counts).
  const onList = () => Boolean(read().newsletter);

  const config = () => {
    try {
      return JSON.parse(document.getElementById('vhp-account-config')?.textContent || '{}');
    } catch (e) {
      return {};
    }
  };
  const apiBase = () => config().apiBase || 'https://vhp-planner.vercel.app';
  const locale = () => ((document.documentElement.lang || 'de').toLowerCase().startsWith('en') ? 'en' : 'de');

  // { recipe, newsletter } from GET /api/signup, kept for the visit (10 minutes).
  let ready = null;
  const loadReady = async () => {
    try {
      const kept = JSON.parse(sessionStorage.getItem(READY_KEY) || 'null');
      if (kept && Date.now() - Number(kept.at || 0) < READY_MS) return (ready = kept);
    } catch (e) {
      /* ask the API */
    }
    try {
      const res = await fetch(`${apiBase()}/api/signup`, { credentials: 'omit' });
      const body = res.ok ? await res.json() : null;
      ready = { recipe: body?.recipe === true, newsletter: body?.newsletter === true, at: Date.now() };
      sessionStorage.setItem(READY_KEY, JSON.stringify(ready));
    } catch (e) {
      ready = ready || { recipe: false, newsletter: false, at: 0 };
    }
    return ready;
  };

  // ---------- entry points ----------

  // Subscribers get the recipes anyway and the newsletter is not for them; the menu row only for non-subscribers.
  const subscriber = () => config().subscriber === true;

  const paint = () => {
    if (!ready) return;
    $$('[data-vhp-mail-recipe]').forEach((btn) => {
      btn.hidden = !ready.recipe;
      // The list button next to it shares the row only while there is a second button (assets/vhp-recipe-sheet.css).
      btn.closest('[data-vhp-ings-actions]')?.classList.toggle('is-pair', ready.recipe);
    });
    $$('[data-vhp-mail-news]').forEach((row) => {
      // No sheet on this page (the planner): no row.
      row.hidden = !ready.newsletter || onList() || subscriber() || !dialog();
    });
  };

  // ---------- the sheet ----------

  let kind = 'recipe';
  let ctx = {};
  let sending = false;
  const dialog = () => $('[data-vhp-ms]');

  const showError = (key) => {
    const dlg = dialog();
    const el = $('[data-vhp-ms-error]', dlg);
    if (!el) return;
    const text = key ? $(`[data-k="${key}"]`, $('[data-vhp-ms-errors]', dlg)?.content || dlg)?.textContent || '' : '';
    el.textContent = text;
    el.hidden = !text;
  };

  const setBusy = (on) => {
    sending = on;
    const btn = $('[data-vhp-ms-send]', dialog());
    if (!btn) return;
    btn.disabled = on;
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    btn.classList.toggle('is-busy', on);
    if (on) btn.dataset.busyText = btn.dataset.tSending || '';
  };

  const showPane = (done) => {
    const dlg = dialog();
    $('[data-vhp-ms-ask]', dlg).hidden = done;
    $('[data-vhp-ms-done]', dlg).hidden = !done;
  };

  // Servings on screen: the recipe's stepper ([data-serv-num]) in the same recipe body, else its standard.
  const servingsOf = (btn) => {
    const body = btn.closest('[data-product-id]') || document;
    const n = parseInt($('[data-serv-num]', body)?.textContent || btn.dataset.servings || '', 10);
    return Number.isFinite(n) && n >= 1 && n <= 12 ? n : 2;
  };

  const open = (which, context = {}) => {
    const dlg = dialog();
    if (!dlg || dlg.open) return false;
    kind = which;
    ctx = context;
    dlg.dataset.kind = which;
    showPane(false);
    showError('');
    setBusy(false);
    const lead = $('[data-vhp-ms-lead]', dlg);
    if (lead && which === 'recipe') {
      const n = ctx.servings || 2;
      const word = (n === 1 ? lead.dataset.tOne : lead.dataset.tOther || '').replace('{n}', n);
      lead.textContent = (lead.dataset.t || '').replace('{servings}', word);
    }
    window.vhpSheet?.setOpen(dlg, true);
    track('mail_signup_open', { kind: which, at: ctx.at || '' });
    return true;
  };

  const close = () => window.vhpSheet?.setOpen(dialog(), false);

  const send = async () => {
    const dlg = dialog();
    if (!dlg || sending) return;
    const input = $('input[name="email"]', dlg);
    const email = String(input?.value || '').trim();
    if (!EMAIL_RE.test(email)) {
      showError('bad_email');
      input?.focus();
      return;
    }
    const body =
      kind !== 'news'
        ? { kind: 'recipe', email, recipe: String(ctx.recipe || ''), ...(ctx.servings ? { servings: ctx.servings } : {}), path: location.pathname, locale: locale() }
        : { kind: 'newsletter', email, locale: locale() };
    body.website = $('input[name="vhp_trap"]', dlg)?.value || '';
    showError('');
    setBusy(true);
    let res = null;
    try {
      // text/plain: no preflight (like the week mail and the events beacon).
      res = await fetch(`${apiBase()}/api/signup`, {
        method: 'POST',
        credentials: 'omit',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
        body: JSON.stringify(body),
      });
    } catch (e) {
      res = null;
    }
    setBusy(false);
    const data = res?.ok ? await res.json().catch(() => ({})) : null;
    if (res?.ok) {
      // Recipe signups make her saves real (vhp-planner src/lib/saverAccount.ts): the background account's key for this
      // browser (assets/vhp-account.js syncs with it), or a login line when the address already has an account.
      const account = data?.account;
      if (account?.customerId && account?.token) {
        try {
          localStorage.setItem('vhp_guest_account', JSON.stringify({ customerId: String(account.customerId), token: account.token, at: new Date().toISOString() }));
        } catch (e) {
          /* private mode: likes stay on this page view */
        }
        window.dispatchEvent(new CustomEvent('vhp:guest-account'));
      }
      const login = $('[data-vhp-ms-login]', dlg);
      if (login) {
        login.hidden = !account?.exists;
        if (account?.exists && window.vhpAccount?.loginUrl) login.href = window.vhpAccount.loginUrl();
      }
      // Both kinds are newsletter signups (the recipe comes once she confirmed): the menu row goes for this browser.
      write({ newsletter: new Date().toISOString() });
      track('mail_signup_sent', { kind, at: ctx.at || '' });
      // Speichern: the like now that she signed up (the reels save through their own code, ctx.onSaved).
      if (kind === 'save' && typeof ctx.onSaved === 'function') ctx.onSaved();
      else if (kind === 'save' && ctx.recipe) saveLike(ctx.recipe);
      const text = $('[data-vhp-ms-done-text]', dlg);
      if (text) {
        text.textContent = (kind !== 'news' ? text.dataset.tRecipe : text.dataset.tNews).replace('{email}', email);
      }
      if (input) input.value = '';
      if (ctx.button) ctx.button.classList.add('is-sent');
      showPane(true);
      paint();
      return;
    }
    const err = res ? await res.json().catch(() => null) : null;
    showError(err?.error === 'rate_limited' || err?.error === 'bad_email' ? err.error : 'other');
    if (err?.error === 'mail_off') {
      // The API can't send this kind right now: its buttons go until the next visit asks again.
      ready = { ...ready, [kind !== 'news' ? 'recipe' : 'newsletter']: false, at: Date.now() };
      try {
        sessionStorage.setItem(READY_KEY, JSON.stringify(ready));
      } catch (e) {
        /* this page only */
      }
      paint();
    }
  };

  // ---------- wiring ----------

  const wire = () => {
    const dlg = dialog();
    if (!dlg || dlg.dataset.wired) return;
    dlg.dataset.wired = '1';
    $('[data-vhp-ms-form]', dlg)?.addEventListener('submit', (event) => {
      event.preventDefault();
      send();
    });
    dlg.addEventListener('click', (event) => {
      // The dialog fills the screen around the panel: a tap on it is a tap on the backdrop.
      if (event.target === dlg || event.target.closest('[data-vhp-ms-close]')) close();
    });
  };

  // ---------- Speichern (sections/main-recipe.liquid head) ----------

  const likes = () => window.vhpPlannerLikes;
  const isSaved = (id) => Boolean(likes()?.read().likes.items.some((item) => item.id === String(id)));
  // The dish as the likes document keeps it, from the recipe body's data (snippets/vhp-recipe-body.liquid root).
  const dishOf = (id) => {
    const body = document.querySelector(`.vhp-recipe-sheet[data-product-id="${id}"]`);
    const d = body?.dataset || {};
    return { id: String(id), handle: d.handle, title: d.title, image: d.image || '', slot: d.slot, kcal: d.kcal, protein: d.protein, carbs: d.carbs, fat: d.fat, time: d.time };
  };
  const paintSave = () => {
    $$('[data-vhp-save]').forEach((btn) => btn.setAttribute('aria-pressed', isSaved(btn.dataset.vhpSave) ? 'true' : 'false'));
  };

  let toastTimer = 0;
  const toast = (text) => {
    let el = $('.rs-toast[data-vhp-ms-toast]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'rs-toast';
      el.dataset.vhpMsToast = '';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = text;
    void el.offsetWidth;
    el.classList.add('is-in');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => el.classList.remove('is-in'), 2600);
  };

  // Unplannable recipes (no meal slot) can't be a like; the mail still saves them for her.
  const saveLike = (id) => {
    const liked = Boolean(likes()?.addLike({ ...dishOf(id), at: new Date().toISOString() }));
    paintSave();
    track('recipe_save', { on: true, liked });
    return liked;
  };

  const onSave = (btn) => {
    const id = btn.dataset.vhpSave;
    if (!id) return;
    if (isSaved(id)) {
      likes()?.removeLike(id);
      paintSave();
      toast(btn.dataset.tRemoved || '');
      track('recipe_save', { on: false });
      return;
    }
    // Saving costs an address (Maxim 2026-11-03): not on the list yet, the sheet asks first and the like is only written
    // once she sent it (saveLike after the send). On the list already, or the API can't take signups: saved at once.
    if (!onList() && ready?.recipe && open('save', { recipe: id, servings: servingsOf(btn), at: 'save', button: btn })) {
      track('recipe_save_ask', {});
      return;
    }
    if (saveLike(id)) toast(btn.dataset.tSaved || '');
  };

  // Delegated: recipe bodies come and go (recipe sheet, router), the menu is a popover.
  document.addEventListener('click', (event) => {
    const saveBtn = event.target.closest('[data-vhp-save]');
    if (saveBtn) {
      event.preventDefault();
      onSave(saveBtn);
      return;
    }
    const recipeBtn = event.target.closest('[data-vhp-mail-recipe]');
    if (recipeBtn) {
      event.preventDefault();
      const body = recipeBtn.closest('[data-product-id]');
      open('recipe', {
        recipe: recipeBtn.dataset.recipe || body?.dataset.productId,
        servings: servingsOf(recipeBtn),
        at: recipeBtn.dataset.at || '',
        button: recipeBtn,
      });
      return;
    }
    const newsRow = event.target.closest('[data-vhp-mail-news]');
    if (newsRow) {
      event.preventDefault();
      // Out of the menu first, so the sheet isn't under it.
      const menu = newsRow.closest('[popover]');
      if (menu) {
        try {
          menu.hidePopover();
        } catch (e) {
          /* already closed */
        }
      }
      open('news', { at: newsRow.dataset.at || 'menu' });
    }
  });

  const start = () => {
    wire();
    paintSave();
    window.addEventListener('vhp:likes-changed', paintSave);
    loadReady().then(paint);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // New recipe bodies (recipe sheet, in-page tab navigation, assets/app-router.js) fire no event: watch for buttons.
  let paintTimer = 0;
  new MutationObserver((records) => {
    if (!ready) return;
    const added = records.some((r) =>
      Array.from(r.addedNodes).some((n) => n.nodeType === 1 && (n.matches?.('[data-vhp-mail-recipe], [data-vhp-mail-news]') || n.querySelector?.('[data-vhp-mail-recipe], [data-vhp-mail-news]')))
    );
    if (!added) return;
    window.clearTimeout(paintTimer);
    paintTimer = window.setTimeout(paint, 50);
  }).observe(document.documentElement, { childList: true, subtree: true });

  // The reels' save button (Maxim 2026-11-03: "Speichern" instead of "In den Wochenplan"): the first save of someone not
  // on the list opens "Rezept speichern"; onSaved runs the reel's own save once she sent her address. false = save now
  // (on the list, the API can't take signups, or no sheet on this page). Servings: the recipe's standard (API).
  const gate = ({ recipe, at, onSaved }) => {
    if (!recipe || onList() || !ready?.recipe) return false;
    if (!open('save', { recipe: String(recipe), at: at || 'reel', onSaved })) return false;
    track('recipe_save_ask', { at: at || 'reel' });
    return true;
  };

  window.vhpMailSignup = { open, paint, gate };
})();
